export class AuditorDetails {
         auditorSubjectId?: number;
         auditorId: number;
         sectionSubjectId: number;
         allowToEdit: boolean;
         isFirstAuditor?: boolean=true;
         subjectName: string;
         subjectNameEn: string;
         classId?: number;
         sectionId?: number;
         sectionName: string;
         sectionNameEn: string;
         className: string;
         classNameEn: string;
         semesterId?: number;
       }
